import { FieldTextArea } from '@snack-uikit/fields';

type CodeProps = {
  code: string;
};

export function Code(props: CodeProps) {
  const { code } = props;

  return (
    <FieldTextArea
      value={code}
      size="l"
      minRows={1}
      readonly
      data-test-id="article-code"
    />
  );
}
